import request from "@/services/request";

async function getCardsRegions(reg_id) {
    try {
        const res = await request({
            endpoint: `/api/getRegionData?regId=${reg_id}`,
            method: 'get'
        });
        if (res.status === 200) {
            return res.data;
        }
        else {
            throw new Error('Ошибка получения данных')
        }
    } catch (e) {
        console.log("Ошибка получения данных " + e);
    }
}

export default getCardsRegions
